export default __webpack_public_path__ + "static/media/2.c4ea4ef8.jpg";